module.exports = "/img/_/_/_/assets/images/creeper/book/common//46.jpg?73d53328e40dc30ba4579ffcaed9ccc3";